<template>
  <el-dropdown :hide-on-click="false" trigger="click" placement="bottom-end">
    <el-button type="info" style="margin-left: 10px">
      表示項目
      <font-awesome-icon icon="caret-down" style="margin-left: 5px" />
    </el-button>
    <el-dropdown-menu slot="dropdown" v-if="sns_type == 'instagram'">
      <el-dropdown-item @click.native="resetReportItems()">初期値に戻す</el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.followers_count" disabled>フォロワー数</el-checkbox></el-dropdown-item>      
      <el-dropdown-item><el-checkbox v-model="item.female_ratio" v-if="list_type == 'post'">フォロワー男女比</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.post_num">投稿数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.impression">インプレッション数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.reach">リーチ数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.engagement_count" disabled>EG</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_engagement">平均EG</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_engagement_only_pr">平均EG(PRのみ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_engagement_diff" v-if="list_type == 'post'">平均EGとの差異</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_engagement_only_pr_diff" v-if="list_type == 'post'">平均EGとの差異(PRのみ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.like_count" disabled>いいね数</el-checkbox></el-dropdown-item>      
      <el-dropdown-item><el-checkbox v-model="item.average_like">平均いいね数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_like_diff" v-if="list_type == 'post'">平均いいね数との差異</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comments_count" disabled>コメント数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_comments">平均コメント数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_comments_diff" v-if="list_type == 'post'">平均コメント数との差異</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.play">リール再生数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_video_play_count">平均リール再生数(合計)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_video_play_count_organic">平均リール再生数(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_video_play_count_pr">平均リール再生数(PR)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_video_play_rate">平均リール視聴率(合計)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_video_play_rate_organic">平均リール視聴率(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_video_play_rate_pr">平均リール視聴率(PR)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.photo_number">写真投稿枚数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.video_number">動画投稿数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.character_number">キャプション文字数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.hashtag_number">指定ハッシュタグ数</el-checkbox></el-dropdown-item>      
      <el-dropdown-item><el-checkbox v-model="item.save">保存数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.share">シェア数</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.impression_rate">インプレッション率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.reach_rate">リーチ率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_engagement_rate" disabled>EGR</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_engagement_impression_rate">EGR(インプレッション数)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.average_engagement_reach_rate">EGR(リーチ数)</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.like_rate">いいね率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.comments_rate">コメント率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.save_rate">保存率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.share_rate">シェア率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.play_rate">再生率</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cost">コスト</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpf">フォロワー単価</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpe">エンゲージメント単価</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpl">いいね単価</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpc">コメント単価</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpi">インプレッション単価</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpr">リーチ単価</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpsv">保存単価</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpsh">シェア単価</el-checkbox></el-dropdown-item>
      <el-dropdown-item><el-checkbox v-model="item.cpp">再生単価</el-checkbox></el-dropdown-item>      
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "reportDisplayButton",
  props: ["sns_type", "list_type"],
  data() {
    return {};
  },
  computed: {
    item() {
      return this.$store.state.report_item;
    },
  },
  created() {},
  mounted() {},
  methods: {
    resetReportItems() {
      this.$store.dispatch("resetReportItems")
    },
  },
  watch: {
    item: {
      handler() {
        this.$store.dispatch("saveReportItems", this.item);
      },
      deep: true,
    },
  },
};
</script>